import { BsFillHandbagFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCartCount } from "../../Redux/reducer/cartReducer";
import { ORDERING_ENABLED } from "../../config/features";

interface CartButtonProps {
  className?: string;
  iconClassName?: string;
}

/** Header / MobileNavbar dono jagah wahi cart icon — count Redux se aata hai */
const CartButton = ({
  className = "",
  iconClassName = "text-white text-3xl",
}: CartButtonProps) => {
  const navigate = useNavigate();
  const count = useSelector(selectCartCount);

  if (!ORDERING_ENABLED) return null;

  return (
    <div
      className={`relative cursor-pointer ${className}`}
      onClick={() => navigate("/cart")}
      aria-label="Cart"
      role="button"
    >
      <BsFillHandbagFill className={iconClassName} />
      {count > 0 && (
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full h-5 min-w-[20px] px-1 flex items-center justify-center">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </div>
  );
};

export default CartButton;
